<template>
  <div>
    <div class="col-md-12 form-wrapper">
      <h2>Login</h2>
      <form id="loginForm" @submit.prevent="login">
        <div class="form-group">
          <label for="username">Username</label>
          <input
            type="string"
            id="username"
            v-model="username"
            name="username"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            v-model="password"
            name="password"
            class="form-control"
          />
        </div>

        <button class="btn btn-success btn-lg" type="submit">Login</button>
      </form>
    </div>
    <span
      >No account yet?
      <router-link class="btn btn-link" :to="{ name: 'register' }"
        >Register</router-link
      ></span
    >

    <div class="alert alert-danger" role="alert" v-if="loginError">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { server } from "@/utils/helper";
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
      loginError: false,
    };
  },
  methods: {
    async login() {
      let loginData = {
        username: this.username.trim(),
        password: this.password.trim(),
      };

      if (loginData.username == "" || loginData.password == "") {
        this.loginError = true;
        this.errorMessage = "Please fill out all fields.";
        return;
      }

      await this._submitToServer(loginData);
      await this.monthInit();
    },
    async _submitToServer(data) {
      try {
        const loginResponse = await axios.post(
          `${server.baseUrl}/auth/login`,
          data
        );
        localStorage.setItem("jwt", loginResponse.data.access_token);
        await this.monthInit();
        router.push({ name: "home" });
      } catch (error) {
        this.loginError = true;
        if (error.response?.status === 404) {
          this.errorMessage = "No user with this username found.";
        } else if (error.response?.status === 401) {
          this.errorMessage = "Incorrect password.";
        } else {
          this.errorMessage = "Error logging in. Please try again.";
        }
        console.log(error);
      }
    },
    async monthInit() {
      const bearerToken = localStorage.getItem("jwt");
      await axios.post(
        `${server.baseUrl}/months/init`,
        {},
        {
          headers: { Authorization: "Bearer " + bearerToken },
        }
      );
    },
  },
};
</script>
